import styled, { css, keyframes } from 'styled-components';

// TAMANIOS ESTANDARES DE PANTALLAS (AUN FALTA TRABAJAR)
export const DesktopFhd = '1920px';
export const DesktopHdPlus = '1440px';
export const DesktopHd = '1366px';
export const Laptop = '1024px';
export const LaptopSmall = '800px';
export const Tablet = '768px';
export const PhonePlus = '600px';
export const Phone = '480px';
export const PhoneSmall = '360px';
export const PhoneExtraSmall = '320px';

// export const Padding = '0 32px';
// export const Padding = '0 16px';

// ESPACIOS ESTANDARES
export const SpaceXxl = '48px';
export const SpaceXl = '32px';
export const SpaceL = '24px';
export const SpaceM = '16px';
export const SpaceS = '12px';
export const SpaceXs = '8px';
export const SpaceXxs = '4px';

// COLORS
export const HrGreen = '#24BB72';
export const HrGreenHover = '#33cc82';
export const HrGreenActive = '#13b165';
export const HrGreenDisabled = '#A7E4C7';
export const HrGray = '#3B3F51';
export const HrGrayHover = '#52576E';
export const HrGrayActive = '#2E3142';
export const HrGrayDisabled = '#B1B2B9';
export const HrDarkOrange = '#F69708';
export const HrLightOrange = '#F7B034';
export const HrRed = '#ED6B75';
export const HrRedHover = '#E05C66';
export const HrCyan = '#3598DC';
export const HrPastelGreen = '#ABEFCF';
export const HrPastelGray = '#D8D9DC';
export const HrPastelOrange = '#FFD893';
export const HrPastelRed = '#F8C4C8';
export const HrPastelCyan = '#C2E0F5';
export const HrDarkGrey = '#767676';
export const HrGrey = '#9A9A9A !important';
export const HrlightGrey = '#B9B9B9';
export const HrlighterGrey = '#DADADA';
export const HrlightestGrey = '#F4F4F4';
export const HrWhite = '#FFFFFF';
export const HrBlack = '#000000';
export const HrButtonHover = '#ECEDF0';
export const HrButtonActive = '#DFE0E2';
export const BumeranColor = '#000DF1';
export const BumeranColorHover = '#3D47F5';
export const ZonajobsColor = '#F27301';
export const ZonajobsColorHover = '#FE633F';
export const HrPrimary = HrGreen;
export const HrSecondary = HrGray;

// FONTS
export const HrFont = `"Open Sans", sans-serif;`;
export const HrFontExtraBold = '700';
export const HrFontBold = '600';
export const HrFontRegular = '400';

// BORDERS
export const HrBorderRadiusInputs = '8px';
export const HrBorderRadiusBoxes = '6px';
export const HrBorderRadius = '4px';

// SVG PATHS
export const HrCheckboxDefault =
  'm 19 5 v 14 H 5 V 5 h 14 m 0 -2 H 5 c -1.1 0 -2 0.9 -2 2 v 14 c 0 1.1 0.9 2 2 2 h 14 c 1.1 0 2 -0.9 2 -2 V 5 c 0 -1.1 -0.9 -2 -2 -2 z';
export const HrCheckboxChecked =
  'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z';
export const HrCheckboxSemiChecked =
  'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z';

// TRANSITIONS
export const HrCubicBezier = 'cubic-bezier(0.465,0.183,0.153,0.946)';
export const HrTransitionDelay = '0s';
export const HrTransitionDuration = '0.5s';
export const HrTransitionProperty = 'all';
export const HrTransitionTimingCunction = HrCubicBezier;
export const HrTransition = `${HrTransitionProperty} ${HrTransitionDuration} ${HrTransitionTimingCunction} ${HrTransitionDelay}`;

/// ///////////////////////////////////// ///
///  COMPONENTES ESTILIZADOS (BASE) V0.1 ///
/// /////////////////////////////////// ///

// SPACES
const HrSpaces = css`
  /* MARGIN TOP */
  ${({ marginTopXxl }) =>
    marginTopXxl &&
    `
    margin-top: ${SpaceXxl}
  `};

  ${({ marginTopXl }) =>
    marginTopXl &&
    `
    margin-top: ${SpaceXl}
  `};

  ${({ marginTopL }) =>
    marginTopL &&
    `
    margin-top: ${SpaceL}
  `};

  ${({ marginTopM }) =>
    marginTopM &&
    `
    margin-top: ${SpaceM}
  `};

  ${({ marginTopS }) =>
    marginTopS &&
    `
    margin-top: ${SpaceS}
  `};

  ${({ marginTopXs }) =>
    marginTopXs &&
    `
    margin-top: ${SpaceXs}
  `};

  ${({ marginTopXxs }) =>
    marginTopXxs &&
    `
    margin-top: ${SpaceXxs}
  `};

  /* MARGIN BOTTOM */
  ${({ marginBottomXxl }) =>
    marginBottomXxl &&
    `
    margin-bottom: ${SpaceXxl}
  `};

  ${({ marginBottomXl }) =>
    marginBottomXl &&
    `
    margin-bottom: ${SpaceXl}
  `};

  ${({ marginBottomL }) =>
    marginBottomL &&
    `
    margin-bottom: ${SpaceL}
  `};

  ${({ marginBottomM }) =>
    marginBottomM &&
    `
    margin-bottom: ${SpaceM}
  `};

  ${({ marginBottomS }) =>
    marginBottomS &&
    `
    margin-bottom: ${SpaceS}
  `};

  ${({ marginBottomXs }) =>
    marginBottomXs &&
    `
    margin-bottom: ${SpaceXs}
  `};

  ${({ marginBottomXxs }) =>
    marginBottomXxs &&
    `
    margin-bottom: ${SpaceXxs}
  `};

  /* MARGIN LEFT */
  ${({ marginLeftXxl }) =>
    marginLeftXxl &&
    `
    margin-left: ${SpaceXxl}
  `};

  ${({ marginLeftXl }) =>
    marginLeftXl &&
    `
    margin-left: ${SpaceXl}
  `};

  ${({ marginLeftL }) =>
    marginLeftL &&
    `
    margin-left: ${SpaceL}
  `};

  ${({ marginLeftM }) =>
    marginLeftM &&
    `
    margin-left: ${SpaceM}
  `};

  ${({ marginLeftS }) =>
    marginLeftS &&
    `
    margin-left: ${SpaceS}
  `};

  ${({ marginLeftXs }) =>
    marginLeftXs &&
    `
    margin-left: ${SpaceXs}
  `};

  ${({ marginLeftXxs }) =>
    marginLeftXxs &&
    `
    margin-left: ${SpaceXxs}
  `};

  /* MARGIN RIGHT */
  ${({ marginRightXxl }) =>
    marginRightXxl &&
    `
    margin-right: ${SpaceXxl}
  `};

  ${({ marginRightXl }) =>
    marginRightXl &&
    `
    margin-right: ${SpaceXl}
  `};

  ${({ marginRightL }) =>
    marginRightL &&
    `
    margin-right: ${SpaceL}
  `};

  ${({ marginRightM }) =>
    marginRightM &&
    `
    margin-right: ${SpaceM}
  `};

  ${({ marginRightS }) =>
    marginRightS &&
    `
    margin-right: ${SpaceS}
  `};

  ${({ marginRightXs }) =>
    marginRightXs &&
    `
    margin-right: ${SpaceXs}
  `};

  ${({ marginRightXxs }) =>
    marginRightXxs &&
    `
    margin-right: ${SpaceXxs}
  `};

  /* PADDING TOP */
  ${({ paddingTopXxl }) =>
    paddingTopXxl &&
    `
    padding-top: ${SpaceXxl}
  `};

  ${({ paddingTopXl }) =>
    paddingTopXl &&
    `
    padding-top: ${SpaceXl}
  `};

  ${({ paddingTopL }) =>
    paddingTopL &&
    `
    padding-top: ${SpaceL}
  `};

  ${({ paddingTopM }) =>
    paddingTopM &&
    `
    padding-top: ${SpaceM}
  `};

  ${({ paddingTopS }) =>
    paddingTopS &&
    `
    padding-top: ${SpaceS}
  `};

  ${({ paddingTopXs }) =>
    paddingTopXs &&
    `
    padding-top: ${SpaceXs}
  `};

  ${({ paddingTopXxs }) =>
    paddingTopXxs &&
    `
    padding-top: ${SpaceXxs}
  `};

  /* PADDING BOTTOM */
  ${({ paddingBottomXxl }) =>
    paddingBottomXxl &&
    `
    padding-bottom: ${SpaceXxl}
  `};

  ${({ paddingBottomXl }) =>
    paddingBottomXl &&
    `
    padding-bottom: ${SpaceXl}
  `};

  ${({ paddingBottomL }) =>
    paddingBottomL &&
    `
    padding-bottom: ${SpaceL}
  `};

  ${({ paddingBottomM }) =>
    paddingBottomM &&
    `
    padding-bottom: ${SpaceM}
  `};

  ${({ paddingBottomS }) =>
    paddingBottomS &&
    `
    padding-bottom: ${SpaceS}
  `};

  ${({ paddingBottomXs }) =>
    paddingBottomXs &&
    `
    padding-bottom: ${SpaceXs}
  `};

  ${({ paddingBottomXxs }) =>
    paddingBottomXxs &&
    `
    padding-bottom: ${SpaceXxs}
  `};

  /* PADDING LEFT */
  ${({ paddingLeftXxl }) =>
    paddingLeftXxl &&
    `
    padding-left: ${SpaceXxl}
  `};

  ${({ paddingLeftXl }) =>
    paddingLeftXl &&
    `
    padding-left: ${SpaceXl}
  `};

  ${({ paddingLeftL }) =>
    paddingLeftL &&
    `
    padding-left: ${SpaceL}
  `};

  ${({ paddingLeftM }) =>
    paddingLeftM &&
    `
    padding-left: ${SpaceM}
  `};

  ${({ paddingLeftS }) =>
    paddingLeftS &&
    `
    padding-left: ${SpaceS}
  `};

  ${({ paddingLeftXs }) =>
    paddingLeftXs &&
    `
    padding-left: ${SpaceXs}
  `};

  ${({ paddingLeftXxs }) =>
    paddingLeftXxs &&
    `
    padding-left: ${SpaceXxs}
  `};

  /* PADDING RIGHT */
  ${({ paddingRightXxl }) =>
    paddingRightXxl &&
    `
    padding-right: ${SpaceXxl}
  `};

  ${({ paddingRightXl }) =>
    paddingRightXl &&
    `
    padding-right: ${SpaceXl}
  `};

  ${({ paddingRightL }) =>
    paddingRightL &&
    `
    padding-right: ${SpaceL}
  `};

  ${({ paddingRightM }) =>
    paddingRightM &&
    `
    padding-right: ${SpaceM}
  `};

  ${({ paddingRightS }) =>
    paddingRightS &&
    `
    padding-right: ${SpaceS}
  `};

  ${({ paddingRightXs }) =>
    paddingRightXs &&
    `
    padding-right: ${SpaceXs}
  `};

  ${({ paddingRightXxs }) =>
    paddingRightXxs &&
    `
    padding-right: ${SpaceXxs}
  `};
`;

// BOXES & CONTAINERS
export const HrBox = css`
  min-width: ${(props) => props.minWidth || '0px'};
  max-width: ${(props) => props.maxWidth || 'none'};
  width: ${(props) => props.width || '100%'};

  min-height: ${(props) => props.minHeight || 'auto'};
  max-height: ${(props) => props.maxHeight || 'none'};
  height: ${(props) => props.height || 'auto'};

  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};

  border-radius: ${(props) => props.borderRadius || HrBorderRadiusBoxes};
  border-width: ${(props) => props.borderWidth || '0px'};
  border-style: ${(props) => props.borderStyle || 'solid'};
  border-color: ${(props) => props.borderColor || '#000'};

  background-color: ${(props) => props.backgroundColor || 'transparent'};

  box-sizing: ${(props) => props.boxSizing || 'border-box'};

  ${HrSpaces}
`;

export const HrBlockContainer = styled.div`
  ${HrBox}

  display: ${(props) => props.display || 'block'};
`;
export const HrFlexContainer = styled.div`
  ${HrBox}

  display: ${(props) => props.display || 'flex'};
  gap: ${(props) => props.gap || '16px'};
  align-items: ${(props) => props.alignItems || 'center'};
  align-self: ${(props) => props.alignSelf || 'auto'};
  flex-direction: ${(props) => props.flexDirection || 'row'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  flex-grow: ${(props) => props.flexGrow || '0'};
  flex-wrap: ${(props) => props.flexWrap || 'wrap'};
  background: ${(props) => props.background || ''};
`;
export const HrGridContainer = styled.div`
  ${HrBox}

  display: ${(props) => props.display || 'grid'};
  grid-template-columns: repeat(${(props) => props.columns || '2'}, 1fr);
  row-gap: ${(props) => props.rowGap || '16px'};
  column-gap: ${(props) => props.columnGap || '16px'};
  align-items: ${(props) => props.alignItems || 'stretch'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
`;
export const GridContainer = styled.div`
  ${HrBox};
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns || '2'}, 1fr);
  width: ${(props) => props.width || 'auto'};
  gap: ${(props) => props.gap || '24px'};
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;
export const HrTitleContainer = styled.div`
  ${HrBox}

  display: ${(props) => props.display || 'flex'};
  gap: ${(props) => props.gap || '16px'};
  align-items: ${(props) => props.alignItems || 'center'};
  flex-direction: ${(props) => props.flexDirection || 'row'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  flex-wrap: ${(props) => props.flexWrap || 'nowrap'};
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0px 32px 16px 32px'};
  border-bottom: ${(props) => props.borderBottom || `1px solid ${HrlighterGrey}`};
  border-radius: 0;

  @media (max-width: ${Tablet}) {
    padding: ${(props) => props.padding || '0px 16px 16px 16px'};
    gap: ${(props) => props.gap || '8px'};
  }
`;
export const Separate = styled.hr`
  border: 0;
  border-color: ${HrlighterGrey};
  border-style: solid;
  border-bottom-width: 1px;
  width: 100%;
  padding: ${(props) => props.padding || '0'};
  margin: ${(props) => props.margin || '8px 0'};
  border-bottom: ${(props) => props.borderBottom || `1px solid ${HrlighterGrey}`};
`;
export const HrTag = styled.div`
  padding: ${(props) => props.padding || '4px 8px'};
  background-color: ${(props) => props.backgroundColor || HrPastelGreen};
  display: ${(props) => props.display || 'flex'};
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: ${(props) => props.alignItems || 'center'};
  gap: ${(props) => props.gap || '4px'};
  border-radius: ${(props) => props.borderRadius || HrBorderRadius};
  height: ${(props) => props.height || '24px'};

  & div {
    background-color: ${HrGreen};
    border-radius: 10px;
    cursor: ${(props) => props.cursor || 'pointer'};
    color: ${HrWhite};
  }
`;
export const HrImageContainer = styled.figure`
  ${HrBox}
  overflow: hidden;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

// TITLES & LABELS
const HrTitle = css`
  font-family: ${HrFont};
  font-weight: ${(props) => props.fontWeight || HrFontBold};
  text-align: ${(props) => props.textAlign || 'left'};
  word-break: ${(props) => props.wordBreak || 'break-word'};
  color: ${(props) => props.color || HrSecondary};
  user-select: ${(props) => props.userSelect || 'auto'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0 !important'};
  padding: ${(props) => props.padding || '0 !important'};

  ${({ isRequired }) =>
    isRequired &&
    `
    &::after {
    content: ' *';
    color: ${HrRed};
  }
  `};
`;
export const HrTitleH1 = styled.h1`
  ${HrTitle};
  font-size: 32px;
`;
export const HrTitleH2 = styled.h2`
  ${HrTitle};
  font-size: ${(props) => `${20 + (props.fontSizeSetting || 0)}px !important`};
`;
export const HrTitleH3 = styled.h3`
  ${HrTitle};
  font-size: 18px;
`;
export const HrTitleH4 = styled.h4`
  ${HrTitle};
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px`};
`;
export const HrTitleH5 = styled.h5`
  ${HrTitle};
  font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
`;
export const HrTitleH6 = styled.h6`
  ${HrTitle};
  font-weight: ${HrFontRegular};
`;
export const HrLabel = styled.label`
  ${HrTitle};
  font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
  cursor: ${(props) => props.cursor || 'pointer'};
`;
export const HrParagraph = styled.p`
  ${HrTitle};
  font-weight: ${(props) => props.fontWeight || HrFontRegular};
  font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
`;
export const HrIconText = styled.p`
  ${HrTitle};
  display: flex;
  align-items: ${(props) => props.alignItems || 'center'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  gap: ${(props) => props.gap || '4px'};
  cursor: ${(props) => props.cursor || 'pointer'};
  font-weight: ${(props) => props.fontWeight || HrFontRegular};
  font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};

  & span,
  & i {
    font-size: ${(props) => props.fontSize || '16px'};
    color: ${(props) => props.color || HrSecondary};
  }
`;
export const HrActionText = styled(HrTitleH5)`
  display: flex;
  align-items: ${(props) => props.alignItems || 'center'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  gap: ${(props) => props.gap || '4px'};
  cursor: ${(props) => props.cursor || 'pointer'};
  margin: ${(props) => props.margin || '0'};

  & span,
  & i {
    font-size: ${(props) => props.fontSize || '16px'};
    color: ${(props) => props.color || HrSecondary};
  }

  &:hover,
  &:hover span,
  &:hover i {
    color: ${(props) => props.colorHover || HrGreenHover};
  }
`;

// BUTTONS & ICONS
export const HrButtons = styled.button`
  font-family: ${HrFont};
  cursor: ${(props) => props.cursor || 'pointer'};
  padding: ${(props) => props.padding || '0 16px'};
  margin: ${(props) => props.margin || '0'};
  border: none;
  color: ${HrWhite};
  border-radius: ${HrBorderRadiusInputs};
  font-weight: ${HrFontBold};
  display: flex;
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: ${(props) => props.alignItems || 'center'};
  width: ${(props) => props.width || 'auto'};
  gap: ${(props) => props.gap || '8px'};
  ${({ category }) =>
    category === 'primary' &&
    `
    background-color: ${HrGreen};

    &:hover {
      background-color: ${HrGreenHover};
    }

    &:active {
      background-color: ${HrGreenActive};
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrGreenDisabled};
      cursor: not-allowed;
    }
  `}

  ${({ category }) =>
    category === 'secondary' &&
    `
    background-color: ${HrGray};

    &:hover {
      background-color: ${HrGrayHover};
    }

    &:active {
      background-color: ${HrGrayActive};
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrGrayDisabled};
      cursor: not-allowed;
    }
  `}

  ${({ category }) =>
    category === 'tertiaryGreen' &&
    `
    background-color: ${HrWhite};
    color: ${HrGreen};
    border: 1px solid ${HrGreen};

    &:hover {
      background-color: #F0FFF8 ;
    }

    &:active {
       background-color: #D5FDEA;
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrWhite};
      cursor: not-allowed;
      color: ${HrGreenDisabled};
      border: 1px solid ${HrGreenDisabled};
    }
  `}

  ${({ category }) =>
    category === 'tertiaryGreenDark' &&
    `
    background-color: transparent;
    color: ${HrGreen};
    border: 1px solid ${HrGreen};

    &:hover {
      background-color: #0B2A1B ;
    }

    &:active {
       background-color: #0B2A1B;
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrWhite};
      cursor: not-allowed;
      color: ${HrGreenDisabled};
      border: 1px solid ${HrGreenDisabled};
    }
  `}

  ${({ category }) =>
    category === 'tertiaryGray' &&
    `
    background-color: ${HrWhite};
    color: ${HrGray};
    border: 1px solid ${HrGray};

    &:hover {
      background-color: ${HrButtonHover};
    }

    &:active {
       background-color: ${HrButtonActive};
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrWhite};
      cursor: not-allowed;
      color: ${HrGrayDisabled};
      border: 1px solid ${HrGrayDisabled};
    }
  `}

  ${({ category }) =>
    category === 'cancel' &&
    `
    background-color: ${HrlighterGrey};
    color: ${HrGray};

    &:hover {
      background-color: #c9c9c9;
    }

    &:active {
       background-color: #c0c0c0;
    }

    &:disabled,
    &[disabled] {
      background-color: #e9e9e9;
      cursor: not-allowed;
      color: #898C97;
    }
  `}

${({ category }) =>
    category === 'actionModeDark' &&
    `
    width: 32px;
    height: 32px;
    background-color: #1A1D2B;
    color: white;
    border: 1px solid white;
    &:hover {
      background-color: #26293A;
    }
  `}

${({ category }) =>
    category === 'actionMode' &&
    `
    width: 32px;
    height: 32px;
    background-color: transparent;
    color: black;
    border: 1px solid black;
    &:hover {
      background-color: #ECEDF0;
    }
  `}


  ${({ size }) =>
    size === 'xlarge' &&
    `
    height: 72px;
    font-size: 16px;
  `}

  ${({ size }) =>
    size === 'large' &&
    `
    height: 48px;
    font-size: 16px;
  `}

  ${({ size }) =>
    size === 'medium' &&
    `
    height: 40px;
    font-size: 14px;
  `}

  ${({ size }) =>
    size === 'small' &&
    `
    height: 32px;
    font-size: 14px;
  `}

  ${({ icon }) =>
    icon &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  `}
`;
export const HrIconButton = styled.span`
  width: 16px;
  height: 16px;
  color: ${(props) => props.color || HrWhite} !important;
  font-size: ${(props) => props.fontSize || ''} !important;
`;

export const HrIcon = styled.span`
  width: 16px;
  height: 16px;
  color: ${(props) => props.color || HrWhite} !important;
`;

// ESTE BOTON LLEGO PARA CUBRIR UNA NECESIDA DE CREAR BOTONES MAS GENERICOS
export const HrCustomButton = styled.button`
  font-family: ${HrFont};
  display: ${(props) => props.display || 'flex'};
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: ${(props) => props.alignItems || 'center'};
  gap: ${(props) => props.gap || '8px'};

  font-size: ${(props) => props.fontSize || '16px'};

  min-width: ${(props) => props.minWidth || '0px'};
  max-width: ${(props) => props.maxWidth || 'none'};
  width: ${(props) => props.width || 'auto'};

  min-height: ${(props) => props.minHeight || 'auto'};
  max-height: ${(props) => props.maxHeight || 'none'};
  height: ${(props) => props.height || 'auto'};

  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};

  border-radius: ${(props) => props.borderRadius || HrBorderRadiusInputs};
  border-width: ${(props) => props.borderWidth || '0px'};
  border-style: ${(props) => props.borderStyle || 'solid'};
  border-color: ${(props) => props.borderColor || '#000'};

  background-color: ${(props) => props.backgroundColor || 'transparent'};
  color: ${(props) => props.color || HrSecondary};

  font-weight: ${(props) => props.fontWeight || HrFontBold};
  text-align: ${(props) => props.textAlign || 'left'};
  word-break: ${(props) => props.wordBreak || 'break-word'};

  box-sizing: ${(props) => props.boxSizing || 'border-box'};

  cursor: ${(props) => props.cursor || 'pointer'};

  &:hover {
    background-color: ${(props) => props.backgroundColorHover || 'transparent'};
    border-color: ${(props) => props.borderColorHover || HrSecondary};
  }

  &:active {
    background-color: ${(props) => props.backgroundColorActive || 'transparent'};
    border-color: ${(props) => props.borderColorActive || HrSecondary};
  }

  &:disabled,
  &[disabled] {
    background-color: ${(props) => props.backgroundColorDisabled || HrGrayDisabled};
    cursor: not-allowed;
  }
`;

// INPUTS [TEXT, SUBMIT]
export const HrInputText = styled.input`
  font-family: ${HrFont};
  font-size: ${(props) => props.fontSize || '14px'};
  width: ${(props) => props.width || '100%'};
  min-width: ${(props) => props.minWidth || '0px'};
  max-width: ${(props) => props.maxWidth || 'none'};
  height: ${(props) => props.height || '40px'};
  padding: ${(props) => props.padding || '8px 16px'};
  background: ${(props) => props.background || ''};
  border-radius: ${HrBorderRadiusInputs};
  border: 1px solid ${HrlighterGrey};
  color: ${(props) => props.color || HrGray};
  box-sizing: border-box !important;

  &::placeholder {
    color: ${HrGrey};
    font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
    font-family: ${HrFont};
  }

  &:focus {
    color: ${(props) => props.color || HrGray};
    border: 1px solid ${(props) => props.border || HrGray};
    outline: none;
  }

  &:focus::placeholder {
    color: ${HrGray};
  }

  &:disabled {
    background: ${(props) => props.backgroundDisabled || HrlightestGrey};
    border: 1px solid ${HrlighterGrey};
    color: ${HrGrey};
    cursor: not-allowed;
  }

  &.error {
    color: ${HrRed};
    border: 1px solid ${HrRed};
  }
  &.error::placeholder {
    color: ${HrRed};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &[type='search'] {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;

    &::-webkit-search-cancel-button {
      -webkit-appearance: button !important;
      appearance: button !important;
      width: auto !important;
      height: auto !important;
    }

    &::-moz-search-cancel-button {
      display: inline-block !important;
    }
  }
`;

export const HrInputPassword = styled.span`
  font-family: ${HrFont};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '40px'};
  padding: ${(props) => props.padding || '8px 16px'};
  background-color: ${(props) => props.backgroundColor || HrWhite};
  border-radius: ${(props) => props.borderRadius || HrBorderRadiusInputs};
  border: 1px solid ${HrlighterGrey};
  color: ${(props) => props.color || HrGray};
  box-sizing: ${(props) => props.boxSizing || 'border-box'};
  position: ${(props) => props.position || 'relative'};

  & .hr-Eye-open,
  & .hr-Eye-off {
    font-size: 20px;
    position: ${(props) => props.position || 'absolute'};
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    cursor: ${(props) => props.cursor || 'pointer'};
    color: ${(props) => props.color || HrSecondary};
  }

  & input::placeholder {
    color: ${(props) => props.color || HrGrey};
    font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
    font-family: ${HrFont};
  }

  &:focus {
    color: ${(props) => props.color || HrGray};
    border: 1px solid ${HrGray};
    outline: none;
  }

  &:focus::placeholder {
    color: ${(props) => props.color || HrGray};
  }

  &:disabled {
    background-color: ${(props) => props.backgroundColor || HrlightestGrey};
    color: ${(props) => props.color || HrGrey};
    border: 1px solid ${HrlighterGrey};
    cursor: not-allowed;
  }

  &.error {
    color: ${(props) => props.color || HrRed};
    border: 1px solid ${HrRed};
  }
  &.error::placeholder {
    color: ${(props) => props.color || HrRed};
  }

  & input {
    font-family: ${HrFont};
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;

    &.error {
      color: ${(props) => props.color || HrRed};
    }
    &.error::placeholder {
      color: ${(props) => props.color || HrRed};
    }
  }
`;
export const HrInputTextWithSymbol = styled.span`
  font-family: ${HrFont};
  font-size: ${(props) => props.fontSize || '14px'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '40px'};
  padding: 8px 16px;
  background: ${(props) => props.background || HrWhite};
  border-radius: ${HrBorderRadiusInputs};
  border: 1px solid ${HrlighterGrey};
  color: ${(props) => props.color || HrGray};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  white-space: ${(props) => props.whiteSpace || 'nowrap'};

  &:focus {
    color: ${HrGray};
    border: 1px solid ${HrGray};
    outline: none;
  }
  &:focus::placeholder {
    color: ${HrGray};
  }
  &:disabled {
    background: ${HrlightestGrey};
    border: 1px solid ${HrlighterGrey};
    color: ${HrGrey};
    cursor: not-allowed;
  }
  &.error {
    color: ${HrRed};
    border: 1px solid ${HrRed};
  }
  &.error::placeholder {
    color: ${HrRed};
  }
  & input {
    font-family: ${HrFont};
    font-size: ${(props) => props.fontSize || '14px'};
    border: none;
    /* outline: 1px solid ${HrlighterGrey}; */
    outline: none;
    margin: 0;
    margin-left: 8px;
    background-color: transparent;
    width: 100%;
    color: ${(props) => props.color || ''};

    &::placeholder {
      color: ${HrGrey};
      font-size: 14px;
      font-family: ${HrFont};
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &[type='number'] {
      -moz-appearance: textfield;
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  &.disabled {
    background: ${HrlightestGrey};
    border: 1px solid ${HrlighterGrey};
    color: ${HrGrey};
    cursor: not-allowed;
  }
`;
export const HrButtonsSubmit = styled.input`
  border: none;
  color: ${HrWhite};
  width: ${(props) => props.width || 'auto'};
  border-radius: ${HrBorderRadiusInputs};
  font-weight: ${HrFontBold};
  cursor: ${(props) => props.cursor || 'pointer'};
  padding: 0 16px;

  ${({ category }) =>
    category === 'primary' &&
    `
    background-color: ${HrGreen};

    &:hover {
      background-color: ${HrGreenHover};
    }

    &:active {
      background-color: ${HrGreenActive};
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrGreenDisabled};
      cursor: not-allowed;
    }
  `}

  ${({ category }) =>
    category === 'secondary' &&
    `
    background-color: ${HrGray};

    &:hover {
      background-color: ${HrGrayHover};
    }

    &:active {
      background-color: ${HrGrayActive};
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrGrayDisabled};
      cursor: not-allowed;
    }
  `}

${({ category }) =>
    category === 'tertiaryGreen' &&
    `
    background-color: ${HrWhite};
    color: ${HrGreen};
    border: 1px solid ${HrGreen};

    &:hover {
      background-color: #F0FFF8 ;
    }

    &:active {
       background-color: #D5FDEA;
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrWhite};
      cursor: not-allowed;
      color: ${HrGreenDisabled};
      border: 1px solid ${HrGreenDisabled};
    }
  `}

${({ category }) =>
    category === 'tertiaryGray' &&
    `
    background-color: ${HrWhite};
    color: ${HrGray};
    border: 1px solid ${HrGray};

    &:hover {
      background-color: ${HrButtonHover};
    }

    &:active {
       background-color: ${HrButtonActive};
    }

    &:disabled,
    &[disabled] {
      background-color: ${HrWhite};
      cursor: not-allowed;
      color: ${HrGrayDisabled};
      border: 1px solid ${HrGrayDisabled};
    }
  `}

${({ category }) =>
    category === 'cancel' &&
    `
    background-color: ${HrlighterGrey};
    color: ${HrGray};

    &:hover {
      background-color: #c9c9c9;
    }

    &:active {
       background-color: #c0c0c0;
    }

    &:disabled,
    &[disabled] {
      background-color: #e9e9e9;
      cursor: not-allowed;
      color: #898C97;
    }
  `}

  ${({ size }) =>
    size === 'large' &&
    `
    height: 48px;
    font-size: 16px;
  `}

  ${({ size }) =>
    size === 'medium' &&
    `
    height: 40px;
    font-size: 14px;
  `}

  ${({ size }) =>
    size === 'small' &&
    `
    height: 32px;
    font-size: 14px;
  `}

  ${({ icon }) =>
    icon &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  `}
`;
const Spin = keyframes` 100% { transform: rotate(360deg)} `;
export const Spinner = styled.span`
  animation: ${Spin} 4s linear infinite;

  ${({ category }) =>
    category === 'primary' &&
    `
    color: ${HrWhite} !important;
  `}

  ${({ category }) =>
    category === 'secondary' &&
    `
    color: ${HrWhite} !important;
  `}

  ${({ category }) =>
    category === 'tertiaryGreen' &&
    `
    color: ${HrPrimary} !important;
  `}

  ${({ category }) =>
    category === 'tertiaryGray' &&
    `
    color: ${HrSecondary} !important;
  `}
`;
// Comentarios, aportes e ideas
//
// hay que hacer un componente para los Selects?
//
// hay que hacer un componente para los checkboxes? deberia no solo contener Labels, si no tambien Inputs y posiblemente otros elementos.
//
// hay que hacer un componente para los radio buttons? deberia no solo contener Labels, si no tambien Inputs y posiblemente otros elementos.
//
// Deberia crear una caja para cuando el contenido debe desbordar, similar al contenedor de los contadores en las Metricas.
//
//  se repite mucho el texto en gris y en verde para dar info extra o realizar una accion, deberia crear dos componentes para esos casos y que los demas hereden de esos propiedades como color, tamaño de fuente o peso de la fuente.
//
// Deberia cambiar el nombre de la variable HtTitle por HrText
//
// tengo que hacer algo para las <img> y <figure>
//
// El <HrGridContainer> me parece echo para un solo caso, deberia sentarme a ver como mejorarlo para futuras cosas
//
// ESTO NO SE PUEDE
/* margin-top: ${(props) => props.marginTop || '0'};
  margin-right: ${(props) => props.marginRight || '0'};
  margin-bottom: ${(props) => props.marginBottom || '0'};
  margin-left: ${(props) => props.marginLeft || '0'}; */
/* padding-top: ${(props) => props.paddingTop || '0'};
  padding-right: ${(props) => props.paddingRight || '0'};
  padding-bottom: ${(props) => props.paddingBottom || '0'};
  padding-left: ${(props) => props.paddingLeft || '0'}; */
